import {Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {FormWrapper} from "../items/form.wrapper";
import {AbstractFormFieldComponent} from "../abstract-form-field.component";

import {ReactiveFormsModule} from "@angular/forms";
import {FormLabelComponent} from "../form-label/form-label.component";
import {isTrue} from "../../utils/epic.utils";
import {Size} from "../../../base/data/size";
import {FormFieldConfig} from "../form-field.config";

@Component({
  selector: 'acc-form-switch',
  imports: [
    ReactiveFormsModule,
    FormLabelComponent
  ],
  templateUrl: './form-switch.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './form-switch.component.css'
})
export class FormSwitchComponent extends AbstractFormFieldComponent {

  @ViewChild('input')
  public input: ElementRef | undefined;

  @Input({required: true})
  public name!: string;

  @Input({required: true})
  public wrapper!: FormWrapper;

  @Input()
  public config: FormFieldConfig = new FormFieldConfig();

  protected override isViewOnly(): boolean {
    return this._isViewOnly(this.name, this.wrapper);
  }

  protected override getSize(): Size | undefined {
    return this.config.size;
  }

  protected isInvalid(): boolean {
    return this._isInvalid(this.name, this.wrapper);
  }

  protected onChange(event: Event): void {
    if (event && event.target instanceof HTMLInputElement) {
      const value: boolean = event.target.checked;
      const newValue: boolean = isTrue(value);
      const oldValue: boolean = isTrue(this.wrapper.form.controls[this.name].value);
      this._onChangeValue(this.name, this.wrapper, newValue, oldValue);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected onClick(_event: Event): void {
    this.input?.nativeElement.blur();
  }
}
